import { gate } from 'hub-http/gates';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import { Select } from 'foundations-components/components/Select';
import { useEligibleUsersForTask } from 'setup-guide-api/dataFetchingClient/queries/assignedTasks';
import AssignTaskUserSelectV2 from './AssignTaskUserSelectV2';
import { useAuth } from '../../hooks/auth';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignTaskUserSelect = ({
  onTeamMemberSelect,
  selectedTeamMemberId,
  taskId
}) => {
  var _eligibleUsersWithout;
  const {
    user,
    gates = []
  } = useAuth();
  const {
    user_id: userId
  } = user;
  const shouldUseNewEligibleUsersEndpoint = gates.includes(gate('GrowthAdoptionCore:AssignedTasksEligibleUsers'));
  const {
    eligibleUsers
  } = useEligibleUsersForTask({
    variables: {
      taskId
    },
    skip: shouldUseNewEligibleUsersEndpoint
  });
  const eligibleUsersWithoutCurrentUser = eligibleUsers === null || eligibleUsers === void 0 ? void 0 : eligibleUsers.filter(eligibleUser => eligibleUser.userId !== userId);
  if (shouldUseNewEligibleUsersEndpoint) {
    return /*#__PURE__*/_jsx(AssignTaskUserSelectV2, {
      onTeamMemberSelect: onTeamMemberSelect,
      selectedTeamMemberId: selectedTeamMemberId,
      taskId: taskId
    });
  }
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": "assign-task-dropdown",
    label: I18n.text('setup-guide-components.assignTaskModal.dropdownLabel'),
    onSelectedOptionChange: ({
      value
    }) => {
      onTeamMemberSelect(Number(value));
    },
    options: (_eligibleUsersWithout = eligibleUsersWithoutCurrentUser === null || eligibleUsersWithoutCurrentUser === void 0 ? void 0 : eligibleUsersWithoutCurrentUser.map(eligibleUser => ({
      text: formatName({
        firstName: eligibleUser.firstName,
        lastName: eligibleUser.lastName
      }) || I18n.text('setup-guide-components.assignTaskModal.newUser'),
      value: eligibleUser.userId
    }))) !== null && _eligibleUsersWithout !== void 0 ? _eligibleUsersWithout : [],
    searchable: true,
    selectedValues: selectedTeamMemberId ? [selectedTeamMemberId] : []
  });
};
export default AssignTaskUserSelect;